<!--
  オンライン健康相談とバーチャル健康相談の両方をこの実装で担当する
-->
<template>
  <div :key="counseling_type">
    <spacer :y="5"/>
    <ul id="scroll-top">

      <stack-item>
        <contents-box title="検索">
          <form v-on:submit="registKeyword">
            <div :class="$style.wordsearch">
              <div :class="$style.wordsearch_form">
                <word-search-form
                  placeholder="名前・フリガナ・IDで検索"
                  v-on:sendValue="receiveValue" />
              </div>
              <i
                :class="$style.wordsearch_btn"
                class="fa-regular fa-magnifying-glass"
                v-on:click="registKeyword"/>
            </div>
          </form>
          <spacer :y="2" />
          <div :class="$style.select">
            <dl>
              <dt>学校ソート</dt>
              <dd>
                <select
                  :class="[$style.select_box, $style.school]"
                  v-model="searchCondition.clientSchool">
                  <option :value="null">指定なし</option>
                  <option
                    v-for="n of clientSchools"
                    :key="n.id"
                    :value="n.id">{{ n.name }}</option>
                </select>
              </dd>
            </dl>
          </div>
          <spacer :y="2" />
          <div>
            <ul :class="$style.select">
              <li v-for="item of activeTypeItems" :key="item.name">
                <input
                  type="checkbox"
                  :id="item.name"
                  :value="item.value"
                  v-model="item.checked">
                <label :for="item.name">{{ item.label }}</label>
                <GuideIcon
                  v-if="item.help"
                  icon='fa-regular fa-circle-question'
                  boxSize='330'
                  :hoverText="item.help"
                  noTransform="true"
                />
              </li>
            </ul>
          </div>
        </contents-box>
      </stack-item>

      <stack-item v-if="flag.showArea.progress">
        <contents-box title="予約" v-if="page === 1">
          <loader-simple :flag="flag.loaders.progress">
            <ul
              :class="$style.reserves"
              v-if="targetCounselorReserve.progress.length">
              <li
                v-for="row in targetCounselorReserve.progress"
                :key="row">
                <div :class="$style.reserve">
                  <contents-box
                    type="inner"
                    :title="formatTimestamp(row.schedule.date, `YYYY年MM月DD日（${row.weekday.label}）HH:00`)"
                    :icon="icon"
                    :innerIcon="innerIcon"
                    :iconColor="iconColor">

                    <spacer :y="1"/>
                    <user-box
                      :user="row.fromUser"
                      :showId="true"
                      :showCocomoniBtn="true"
                      :ownUser="user"
                      :bg="userBoxColor(row.fromUser)"
                      type="inner"
                      :link="`/counselor/history/${row.id}/?type=${tab}`"
                      :targetBlank="true"
                      :saveTab="tab"
                      :enableCounselorMessage="true"
                      :isMyCustomer="isMyCustomer(row.fromUser.id)">
                      <template v-slot:btn>
                        <div :class="$style.list_wrap">
                          <div :class="$style.top_btn">
                            <i
                              v-on:click="changeOpenIds(row.id, 'reserve')"
                              v-if="openIds.reserve.includes(row.id)"
                              :class="$style.icon"
                              class="fa-regular fa-minus"></i>
                            <i
                              v-on:click="changeOpenIds(row.id, 'reserve'), getMostRect(row)"
                              v-if="!openIds.reserve.includes(row.id)"
                              :class="$style.icon"
                              class="fa-regular fa-plus"></i>
                          </div>
                        </div>
                      </template>
                      <template v-slot:main>
                        <div
                          :class="$style.drawer"
                          v-if="openIds.reserve.includes(row.id)">
                          <spacer :y="2"/>
                          <ul :class="$style.detail">
                            <li v-if="row.meeting">
                              <label-box label="URL" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content"><a :href="row.meeting.join_url" target="_blank">{{ row.meeting.join_url }}</a></p>
                            </li>
                            <li>
                              <label-box label="お悩み" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="[$style.value, $style.type, hasSubTypesRecorded(row) ? $style.typeCompany : '']">
                                <p
                                  v-for="typeNum in sortWorryTypes(row.type)"
                                  :key="typeNum">{{ getWorryTypeLabel(typeNum, isCompany(row), 'reserve') }}<span v-if="row.other_text && typeNum === 6">（{{ row.other_text }}）</span>
                                  <span v-if="getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporate(row), 'reserve') }}</span>
                                </p>
                              </div>
                            </li>
                            <li class="n2br">
                              <label-box label="相談内容" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content" v-html="getCustomerMemo(row.memos.customer)"></p>
                            </li>
                            <li>
                              <label-box label="ココモニ" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="$style.content">
                                <p :class="$style.who5score">
                                  <span :class="$style.who5label">ココモニチェック</span>{{ row.scoreWho5 }}点
                                  <i class="fa-solid fa-chart-line" :class="$style.chartIcon" @click="showUserChart(row.fromUser)" title="推移グラフ"/>
                                </p>
                                <spacer :y="2"/>
                                <ul :class="$style.who5">
                                  <li v-for="(item, i) in row.who5Answer.answers" :key="item">
                                    <p>{{ helper.master.who5.items[i].label }}</p>
                                    <p :class="$style.who5_answer">{{ helper.master.who5.labels[item] }}</p>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="n2br">
                              <label-box :label="isCompany(row) ? '企業コメント' : '学校コメント'" color="gray" size="sm" :class="$style.label" smAlign="left"
                                :showNew="newFlagsChecker(row)"/>
                              <div
                                :class="$style.content"
                                v-if="row.memos.teacher.length && row.memos.teacher[0].memo && row.memos.teacher[0].memo !== ''">
                                <!-- 投稿者「[管理者/副管理者]・氏名 [最終更新日時]」を表示（11は文言統一で「主」を付けない・職階は出さない） -->
                                <p :class="$style.postUser">{{ getMemoAuthorName(row.memos.teacher[0]) }} [{{ filterMoment(row.memos.teacher[0].updated_at, 'YYYY.MM.DD HH:mm') }}]</p>
                                <p v-html="row.memos.teacher[0].memo"></p>
                              </div>
                              <p
                                :class="$style.content"
                                v-else>記入なし</p>
                            </li>
                            <li class="n2br" :class="$style.fReserve_center">
                              <label-box label="オンライン<br>バーチャル<br>予約" color="gray" size="sm" :class="[$style.label, $style.fReserve_content]" smAlign="left"></label-box>
                              <ul v-if="row.nearest && row.nearest.length" :class="$style.nearest_box">
                                <li v-for="fReserve in row.nearest" :key="fReserve">
                                  <table>
                                    <tr>
                                      <td :class="$style.fReserve_label">申込日</td>
                                      <td :class="$style.fReserve_value">{{ formatTimestamp(fReserve.created_at, 'YYYY/MM/DD  HH:mm') }}</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">実施情報</td>
                                      <td :class="[$style.fReserve_value, $style.counseling_wrap]">
                                        {{ formatTimestamp(fReserve.schedule.date, `YYYY/MM/DD  HH:00〜HH:45`) }}　{{ fReserve.toUser.username }}
                                        <i
                                          v-if="fReserve._counselingType.counseling_type === 1"
                                          class="fa-regular fa-laptop"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.online,
                                          ]"
                                        ><i :class="$style.counseling_icon_inner" class="fa-regular fa-user-headset"/></i>
                                        <i
                                          v-if="fReserve._counselingType.counseling_type === 3"
                                          class="fa-solid fa-vr-cardboard"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.virtual,
                                          ]"
                                        ></i>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">お悩み</td>
                                      <td :class="$style.fReserve_value"><span v-for="wType in sortWorryTypes(fReserve.type)" :key="wType" :class="hasSubTypesRecorded(fReserve) ? $style.fReserveTypeCompany : ''">{{ getWorryTypeLabel(wType, isCompany(row), 'reserve') }}
                                        <span v-if="getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve') }}</span><template v-if="!hasSubTypesRecorded(fReserve)">　</template></span></td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">相談内容</td>
                                      <td :class="$style.fReserve_value">{{ getCustomerMemo(fReserve.memos.customer) }}</td>
                                    </tr>
                                  </table>
                                </li>
                              </ul>
                              <p v-else :class="$style.fReserve_none">以降の予約無し</p>
                            </li>
                          </ul>
                          <spacer :y="3"/>
                          <btn-container>
                            <basic-btn target="_blank" size="sm" :to="`/counselor/history/${row.id}/?type=${tab}`">利用者相談履歴・カルテ記入</basic-btn>
                          </btn-container>

                          <user-watch-btn
                            :customer="row.fromUser"
                            :counseling_type="counseling_type"
                            :counseling_data="row"
                            @update-user-watch-data="afterUpdateUserWatchData"
                          />

                        </div>
                      </template>
                    </user-box>
                  </contents-box>
                </div>
              </li>
            </ul>

            <p v-else-if="!flag.loaders.progress">現在{{ counselingName }}の予約はありません。</p>
          </loader-simple>
        </contents-box>
      </stack-item>


      <stack-item v-if="flag.showArea.report">
        <contents-box title="報告書未記入" v-if="page === 1">
          <loader-simple :flag="flag.loaders.report">
            <ul
              :class="$style.reserves"
              v-if="targetCounselorReserve.report.length">
              <li
                v-for="row in targetCounselorReserve.report"
                :key="row">
                <div :class="$style.reserve">
                  <contents-box
                    type="inner"
                    :title="formatTimestamp(row.schedule.date, `YYYY年MM月DD日（${row.weekday.label}）HH:00`)"
                    :icon="icon"
                    :innerIcon="innerIcon"
                    :iconColor="iconColor">

                    <spacer :y="1"/>
                    <user-box
                      type="inner"
                      :link="`/counselor/history/${row.id}/?type=${tab}`"
                      :targetBlank="true"
                      :bg="userBoxColor(row.fromUser)"
                      :showCocomoniBtn="true" :ownUser="user"
                      :user="row.fromUser" :showId="true"
                      :enableCounselorMessage="true"
                      :isMyCustomer="isMyCustomer(row.fromUser.id)">
                      <template v-slot:btn>
                        <div :class="$style.list_wrap">
                          <div :class="$style.top_btn">
                            <i
                              v-on:click="changeOpenIds(row.id, 'reserve')"
                              v-if="openIds.reserve.includes(row.id)"
                              :class="$style.icon"
                              class="fa-regular fa-minus"></i>
                            <i
                              v-on:click="changeOpenIds(row.id, 'reserve'), getMostRect(row)"
                              v-if="!openIds.reserve.includes(row.id)"
                              :class="$style.icon"
                              class="fa-regular fa-plus"></i>
                          </div>
                        </div>
                      </template>
                      <template v-slot:main>
                        <div
                          :class="$style.drawer"
                          v-if="openIds.reserve.includes(row.id)">
                          <spacer :y="2"/>
                          <ul :class="$style.detail">
                            <li v-if="row.meeting">
                              <label-box label="URL" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content"><a :href="row.meeting.join_url" target="_blank">{{ row.meeting.join_url }}</a></p>
                            </li>
                            <li>
                              <label-box label="お悩み" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="[$style.value, $style.type, hasSubTypesRecorded(row) ? $style.typeCompany : '']">
                                <p
                                  v-for="typeNum in sortWorryTypes(row.type)"
                                  :key="typeNum">{{ getWorryTypeLabel(typeNum, isCompany(row), 'reserve') }}<span v-if="row.other_text && typeNum === 6">（{{ row.other_text }}）</span>
                                  <span v-if="getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporate(row), 'reserve') }}</span>
                                </p>
                              </div>
                            </li>
                            <li class="n2br">
                              <label-box label="相談内容" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content" v-html="getCustomerMemo(row.memos.customer)"></p>
                            </li>
                            <li>
                              <label-box label="ココモニ" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="$style.content">
                                <p :class="$style.who5score">
                                  <span :class="$style.who5label">ココモニチェック</span>{{ row.scoreWho5 }}点
                                  <i class="fa-solid fa-chart-line" :class="$style.chartIcon" @click="showUserChart(row.fromUser)" title="推移グラフ"/>
                                </p>
                                <spacer :y="2"/>
                                <ul :class="$style.who5">
                                  <li v-for="(item, i) in row.who5Answer.answers" :key="item">
                                    <p>{{ helper.master.who5.items[i].label }}</p>
                                    <p>{{ helper.master.who5.labels[item] }}</p>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="n2br">
                              <label-box :label="isCompany(row) ? '企業コメント' : '学校コメント'" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div
                                :class="$style.content"
                                v-if="row.memos.teacher.length && row.memos.teacher[0].memo && row.memos.teacher[0].memo !== ''">
                                <!-- 投稿者「[管理者/副管理者]・氏名 [最終更新日時]」を表示（11は文言統一で「主」を付けない・職階は出さない） -->
                                <p :class="$style.postUser">{{ getMemoAuthorName(row.memos.teacher[0]) }} [{{ filterMoment(row.memos.teacher[0].updated_at, 'YYYY.MM.DD HH:mm') }}]</p>
                                <p v-html="row.memos.teacher[0].memo"></p>
                              </div>
                              <p
                                :class="$style.content"
                                v-else>記入なし</p>
                            </li>
                            <li class="n2br" :class="$style.fReserve_center">
                              <label-box label="オンライン<br>バーチャル<br>予約" color="gray" size="sm" :class="[$style.label, $style.fReserve_content]" smAlign="left"></label-box>
                              <ul v-if="row.nearest && row.nearest.length" :class="$style.nearest_box">
                                <li v-for="fReserve in row.nearest" :key="fReserve">
                                  <table>
                                    <tr>
                                      <td :class="$style.fReserve_label">申込日</td>
                                      <td :class="$style.fReserve_value">{{ formatTimestamp(fReserve.created_at, 'YYYY/MM/DD  HH:mm') }}</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">実施情報</td>
                                      <td :class="[$style.fReserve_value, $style.counseling_wrap]">
                                        {{ formatTimestamp(fReserve.schedule.date, `YYYY/MM/DD  HH:00〜HH:45`) }}　{{ fReserve.toUser.username }}
                                        <i
                                          v-if="fReserve._counselingType.counseling_type === 1"
                                          class="fa-regular fa-laptop"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.online,
                                          ]"
                                        ><i :class="$style.counseling_icon_inner" class="fa-regular fa-user-headset"/></i>
                                        <i
                                          v-if="fReserve._counselingType.counseling_type === 3"
                                          class="fa-solid fa-vr-cardboard"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.virtual,
                                          ]"
                                        ></i>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">お悩み</td>
                                      <td :class="$style.fReserve_value"><span v-for="wType in sortWorryTypes(fReserve.type)" :key="wType" :class="hasSubTypesRecorded(fReserve) ? $style.fReserveTypeCompany : ''">{{ getWorryTypeLabel(wType, isCompany(row), 'reserve') }}
                                        <span v-if="getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve') }}</span><template v-if="!hasSubTypesRecorded(fReserve)">　</template></span></td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">相談内容</td>
                                      <td :class="$style.fReserve_value">{{ getCustomerMemo(fReserve.memos.customer) }}</td>
                                    </tr>
                                  </table>
                                </li>
                              </ul>
                              <p v-else :class="$style.fReserve_none">以降の予約無し</p>
                            </li>
                          </ul>
                          <spacer :y="3"/>
                          <btn-container>
                            <basic-btn size="sm" :to="`/counselor/report/${row.id}/`">報告書を記入する</basic-btn>
                            <spacer :x="2"/>
                            <basic-btn
                              size="sm"
                              tag="button"
                              type="bg"
                              addClass="danger"
                              @click="cancel(row)">当日キャンセル</basic-btn>
                          </btn-container>

                          <user-watch-btn
                            :customer="row.fromUser"
                            :counseling_type="counseling_type"
                            :counseling_data="row"
                            @update-user-watch-data="afterUpdateUserWatchData"
                          />

                        </div>
                      </template>
                    </user-box>
                  </contents-box>
                </div>
              </li>
            </ul>

            <p v-else-if="!flag.loaders.report">現在報告書記入待ちの{{ counselingName }}はありません。</p>
          </loader-simple>
        </contents-box>
      </stack-item>


      <stack-item>
        <contents-box title="実施済み">
          <loader-simple :flag="flag.loaders.finished">
            <pagination
              v-if="!flag.loaders.finished && pageMax && pageMax !== 1"
              :page="page"
              :pageMax="pageMax"
              :path="`/counselor/?tab=${tab}`" />

            <spacer
              v-if="!flag.loaders.finished
                && targetCounselorReserve.finished[page]
                && targetCounselorReserve.finished[page].length"
              :y="4" />
            <ul
              :class="$style.reserves"
              v-if="targetCounselorReserve.finished[page]
                && targetCounselorReserve.finished[page].length
                && !flag.loaders.finished">
              <li v-for="row in targetCounselorReserve.finished[page]" :key="row">
                <div :class="$style.reserve">
                  <contents-box
                    type="inner"
                    :title="`${formatTimestamp(row.schedule.date, `YYYY年MM月DD日（${row.weekday.label}）HH:00`)}${row.flag === 901 ? '<small>キャンセル</small>' : row.flag === 902 ? '<small>当日キャンセル</small>' : ''}`"
                    :icon="icon"
                    :innerIcon="innerIcon"
                    :iconColor="iconColor">

                    <spacer :y="1"/>
                    <user-box
                      type="inner"
                      :link="`/counselor/history/${row.id}/?type=${tab}&isHistory=true`"
                      :targetBlank="true"
                      :showCocomoniBtn="true" :ownUser="user"
                      :bg="userBoxColor(row.fromUser)"
                      :user="row.fromUser" :showId="true"
                      :enableCounselorMessage="true"
                      :isMyCustomer="isMyCustomer(row.fromUser.id)">
                      <template v-slot:btn>
                        <div :class="$style.list_wrap">
                          <div :class="$style.top_btn">
                            <i
                              v-on:click="changeOpenIds(row.id, 'reserve')"
                              v-if="openIds.reserve.includes(row.id)"
                              :class="$style.icon"
                              class="fa-regular fa-minus"></i>
                            <i
                              v-on:click="changeOpenIds(row.id, 'reserve'), getMostRect(row)"
                              v-if="!openIds.reserve.includes(row.id)"
                              :class="$style.icon"
                              class="fa-regular fa-plus"></i>
                          </div>
                        </div>
                      </template>
                      <template v-slot:main>
                        <div
                          :class="$style.drawer"
                          v-if="openIds.reserve.includes(row.id)">
                          <spacer :y="2"/>
                          <ul :class="$style.detail">
                            <li v-if="row.meeting">
                              <label-box label="URL" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content"><a :href="row.meeting.join_url" target="_blank">{{ row.meeting.join_url }}</a></p>
                            </li>
                            <li>
                              <label-box label="お悩み" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="[$style.value, $style.type, hasSubTypesRecorded(row) ? $style.typeCompany : '']">
                                <p
                                  v-for="typeNum in sortWorryTypes(row.type)"
                                  :key="typeNum">{{ getWorryTypeLabel(typeNum, isCompany(row), 'reserve') }}<span v-if="row.other_text && typeNum === 6">（{{ row.other_text }}）</span>
                                  <span v-if="getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporate(row), 'reserve') }}</span>
                                </p>
                              </div>
                            </li>
                            <li class="n2br">
                              <label-box label="相談内容" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content" v-html="getCustomerMemo(row.memos.customer)"></p>
                            </li>
                            <li>
                              <label-box label="ココモニ" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="$style.content">
                                <p :class="$style.who5score">
                                  <span :class="$style.who5label">ココモニチェック</span>{{ row.scoreWho5 }}点
                                  <i class="fa-solid fa-chart-line" :class="$style.chartIcon" @click="showUserChart(row.fromUser)" title="推移グラフ"/>
                                </p>
                                <spacer :y="2"/>
                                <ul :class="$style.who5">
                                  <li v-for="(item, i) in row.who5Answer.answers" :key="item">
                                    <p>{{ helper.master.who5.items[i].label }}</p>
                                    <p>{{ helper.master.who5.labels[item] }}</p>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="n2br">
                              <label-box :label="isCompany(row) ? '企業コメント' : '学校コメント'" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div
                                :class="$style.content"
                                v-if="row.memos.teacher.length && row.memos.teacher[0].memo && row.memos.teacher[0].memo !== ''">
                                <!-- 投稿者「[管理者/副管理者]・氏名 [最終更新日時]」を表示（11は文言統一で「主」を付けない・職階は出さない） -->
                                <p :class="$style.postUser">{{ getMemoAuthorName(row.memos.teacher[0]) }} [{{ filterMoment(row.memos.teacher[0].updated_at, 'YYYY.MM.DD HH:mm') }}]</p>
                                <p v-html="row.memos.teacher[0].memo"></p>
                              </div>
                              <p
                                :class="$style.content"
                                v-else>記入なし</p>
                            </li>
                            <li
                              class="n2br"
                              v-if="row.cancel_reason">
                              <label-box label="キャンセル理由" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="$style.cancel_detail">
                                <p :class="$style.content">{{ helper.master.labels.reserve.cancel_reason[row.cancel_reason] }}{{ getAccountTypeLabel(row) }}</p>
                                <dl :class="$style.comment" v-if="row.memos.cancel.length">
                                  <dt>コメント</dt>
                                  <dd>{{ row.memos.cancel[0].memo }}</dd>
                                </dl>
                              </div>
                            </li>
                            <li class="n2br" :class="$style.fReserve_center">
                              <label-box label="オンライン<br>バーチャル<br>予約" color="gray" size="sm" :class="[$style.label, $style.fReserve_content]" smAlign="left"></label-box>
                              <ul v-if="row.nearest && row.nearest.length" :class="$style.nearest_box">
                                <li v-for="fReserve in row.nearest" :key="fReserve">
                                  <table>
                                    <tr>
                                      <td :class="$style.fReserve_label">申込日</td>
                                      <td :class="$style.fReserve_value">{{ formatTimestamp(fReserve.created_at, 'YYYY/MM/DD  HH:mm') }}</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">実施情報</td>
                                      <td :class="$style.fReserve_value">
                                        {{ formatTimestamp(fReserve.schedule.date, `YYYY/MM/DD  HH:00〜HH:45`) }}　{{ fReserve.toUser.username }}
                                        <i
                                          v-if="fReserve._counselingType.counseling_type === 1"
                                          class="fa-regular fa-laptop"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.online,
                                          ]"
                                        ><i :class="$style.counseling_icon_inner" class="fa-regular fa-user-headset"/></i>
                                        <i
                                          v-if="fReserve._counselingType.counseling_type === 3"
                                          class="fa-solid fa-vr-cardboard"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.virtual,
                                          ]"
                                        ></i>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">お悩み</td>
                                      <td :class="$style.fReserve_value"><span v-for="wType in sortWorryTypes(fReserve.type)" :key="wType" :class="hasSubTypesRecorded(fReserve) ? $style.fReserveTypeCompany : ''">{{ getWorryTypeLabel(wType, isCompany(row), 'reserve') }}
                                        <span v-if="getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve') }}</span><template v-if="!hasSubTypesRecorded(fReserve)">　</template></span></td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">相談内容</td>
                                      <td :class="$style.fReserve_value">{{ getCustomerMemo(fReserve.memos.customer) }}</td>
                                    </tr>
                                  </table>
                                </li>
                              </ul>
                              <p v-else :class="$style.fReserve_none">以降の予約無し</p>
                            </li>
                          </ul>
                          <spacer :y="3"/>
                          <btn-container>
                            <basic-btn size="sm" target="_blank" :to="`/counselor/registed-report/${row.id}/`">報告書を確認する</basic-btn>
                          </btn-container>

                          <user-watch-btn
                            :customer="row.fromUser"
                            :counseling_type="counseling_type"
                            :counseling_data="row"
                            @update-user-watch-data="afterUpdateUserWatchData"
                          />

                          <risk-application-btn
                            v-if="!isVirtual"
                            :counseling_type="counseling_type"
                            :foreign_id="row.id"
                            :target_user_id="row.fromUser.id"
                          />

                        </div>
                      </template>
                    </user-box>
                  </contents-box>
                </div>
              </li>
            </ul>

            <spacer :y="4" />
            <spacer v-if="flag.loaders.finished" :y="6" />
            <pagination
              v-if="!flag.loaders.finished && pageMax && pageMax !== 1"
              :page="page"
              :pageMax="pageMax"
              :path="`/counselor/?tab=${tab}`" />
            <p
              v-else-if="!flag.loaders.finished
                && !targetCounselorReserve.finished[page].length">実施済みの{{ counselingName }}はありません。</p>
          </loader-simple>
        </contents-box>
      </stack-item>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import UserBox from '@/views/components/UserBox.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import Spacer from '@/views/components/Spacer.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import cf from '@/mixins/commonFunctions.js';
import corporateSchool from '@/mixins/corporateSchool.js';
import Pagination from '@/views/components/Pagination.vue';
import RiskApplicationBtn from '@/views/pages/Counselor/parts/RiskApplicationBtn.vue';
import WordSearchForm from '@/views/components/WordSearchForm.vue';
import UserWatchBtn from '@/views/pages/Counselor/parts/UserWatchBtn.vue';
import GuideIcon from '@/views/components/GuideIcon.vue';

export default {
  name: 'counselor-counseling-impl',
  props: [
    'tab', // 'online' || 'virtual'
    'type', // 'reserve' || 'virtualReserve'
    'counseling_type', // 1 || 3
  ],
  mixins: [cf, corporateSchool],
  components: {
    StackItem,
    ContentsBox,
    UserBox,
    LabelBox,
    Spacer,
    BasicBtn,
    BtnContainer,
    LoaderSimple,
    Pagination,
    RiskApplicationBtn,
    WordSearchForm,
    UserWatchBtn,
    GuideIcon,
  },
  data() {
    return {
      flag: {
        loaders: {
          progress: true,
          report: true,
          finished: true,
        },
        showArea: {
          progress: true,
          report: true,
          // finished: true, // 実施済みは常に表示
        },
      },
      openIds: {
        reserve: [],
        report: [],
      },
      page: 1,
      pageMax: 1,
      limit: 5,
      searchCondition: {
        keyword: null,
        targetColumn: [],
        clientSchool: null, // クライアントの所属学校
      },
      clientSchools: [], // 今までに担当したクライアントの所属学校データ
      activeTypeItems: [ // チェックボックスで表現する検索条件
        {
          name: 'isWatched',
          label: '２週間アラート設定中の利用者',
          value: 1,
          checked: false,
        },
        {
          name: 'onlyMyClient',
          label: '担当最終相談（実施済み）',
          value: 1,
          checked: false,
          help: 'テキスト・オンラインに関わらず最終の健康相談を対応した利用者の情報を検索表示します。\n医師・心理士は対象の利用者に対し、「２週間アラート」の設定や、該当利用者に対して「先生からのメッセージ」を送ることができます。',
        },
        // {
        //   name: 'onlyLatestByUser',
        //   label: '実施済み: 最新のみ表示',
        //   value: 1,
        //   checked: false,
        // },
      ],
      myWatchedClients: [], // ２週間アラート監視対象ユーザのうち、自分が最終相談者になっているユーザ
    };
  },
  created() {
    // ストアのカウンセラー用データをクリア
    this.$store.commit('user/counseling/clearCounselorDatas');

    // 今までに担当したクライアントの所属学校データを取得
    this.getClientSchools();

    const query = this.$route.query;
    if (query.page) {
      this.page = Number(query.page);
    } else if (query.tab === this.tab) {
      this.$router.replace(`/counselor/?tab=${this.tab}&page=1`);
    }
    // 実施済みを取得してから予約・報告書未記入を取得
    this.getFinished();
  },
  watch: {
    $route() {
      if (this.$route.query.tab !== this.tab) return;

      const query = this.$route.query;
      if (query.page) {
        this.page = Number(query.page);
      } else if (query.tab === this.tab) {
        // queryにpageがなければ追加してreplace
        this.$router.replace(`/counselor/?tab=${this.tab}&page=1`);
        return;
      }

      // 実施済みの指定ページにデータがなければ取得
      if (!this.targetCounselorReserve.finished[this.page]
        || (this.targetCounselorReserve.finished[this.page]
          && !this.targetCounselorReserve.finished[this.page].length)) {
        this.flag.loaders.finished = true;
        this.getFinished();
      }
    },
  },
  computed: {
    ...mapState(['user', 'helper']),
    isVirtual() {
      return this.tab === 'virtual';
    },
    targetReserves() {
      return this.isVirtual ? this.user.counseling.virtualReserves : this.user.counseling.reserves;
    },
    targetCounselorReserve() {
      return this.isVirtual ? this.user.counseling.counselor.virtualReserve : this.user.counseling.counselor.reserve;
    },
    counselingName() {
      return this.isVirtual ? 'バーチャル健康相談' : 'オンライン健康相談';
    },
    icon() {
      return !this.isVirtual
        ? '<i class="fa-regular fa-laptop" />'
        : '<i class="fa-solid fa-vr-cardboard" />';
    },
    innerIcon() {
      return !this.isVirtual
        ? '<i class="fa-regular fa-user-headset" />'
        : '';
    },
    iconColor() {
      return !this.isVirtual ? 'orange' : 'green';
    },
  },
  methods: {
    showUserChart(user) {
      if (!user || !user.school || !user.school.length) return;
      const args = {
        modalName: 'user-chart-who5',
        data: {
          school: user.school[0],
          user,
          hideChangeUser: true,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
    /**
     * 実施済みの予約取得
     * @param {boolean} isForceGet - 強制的に取得するかどうか
     */
    async getFinished(isForceGet = false) {

      // 自分が最終相談者になっている相談者データを取得
      await this.getMyWatchedClients();

      // 予約取得
      const params = {
        finished: 1,
        to_user_id: this.user.id,
        withWho5: true,
        withType: true,
        withMeeting: true,
        isUserWatch: 1,
        isRisk: 1,
        orderBy: 'desc',
        page: this.page,
        limit: this.limit,
        flags: [11, 901, 902],
        counseling_type: this.counseling_type,
        targetColumn: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.targetColumn : null,
        keyword: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.keyword : null,
        school_id: this.searchCondition.clientSchool || null,
        only_watched_user: this.isOnlyWatchedUser(),
        only_my_client_data: this.isOnlyMyClient(),
        only_my_client_counselor_id: this.isOnlyMyClient() ? this.user.id : null,
        only_latest_by_user: this.isOnlyWatchedUser() || this.isOnlyMyClient(), // 実施済みデータ取得の場合のみパラメータ追加
      };

      // 表示エリアの制御
      this.flag.showArea.progress = this.isOnlyMyClient() === 0;
      this.flag.showArea.report = this.isOnlyMyClient() === 0;

      this.axios({
        method: 'GET',
        url: '/v2/reserve/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.result;
          this.pageMax = res.lastPage;
          const commitData = {
            type: this.type,
            division: 'finished',
            page: this.page,
            values: cf.downSortReserves(res.data),
          };
          this.$store.commit('user/counseling/putCounselorDatas', commitData);

          // 予約（未実施）は1ページ目でしか表示しない。
          // すでに読み込み済みの場合は再取得しない
          if (isForceGet || (this.page === 1 && !this.targetCounselorReserve.progress.length)) {
            this.getProgress(isForceGet);
          } else {
            this.flag.loaders.progress = false;
            // 報告書の下書き、登録を行ったとき用
            if (this.targetCounselorReserve.report.length) this.flag.loaders.report = false;
            else this.getReport();
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loaders.finished = false;
        });
    },

    /**
     * 未実施の予約を取得
     * @param {boolean} isForceGet - 強制的に取得するかどうか
     */
    getProgress(isForceGet) {
      const params = {
        to_user_id: this.user.id,
        orderBy: 'desc',
        progress: 1,
        withWho5: true,
        withType: true,
        withMeeting: true,
        isUserWatch: 1,
        isRisk: 1,
        counseling_type: this.counseling_type,
        targetColumn: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.targetColumn : null,
        keyword: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.keyword : null,
        school_id: this.searchCondition.clientSchool || null,
        only_watched_user: this.isOnlyWatchedUser(),
        only_my_client_data: this.isOnlyMyClient(),
        only_my_client_counselor_id: this.isOnlyMyClient() ? this.user.id : null,
      };

      this.axios({
        method: 'GET',
        url: '/v2/reserve/get/list',
        params,
      })
        .then((response) => {
          const data = response.data.result.data;
          const commitData = {
            userId: this.user.id,
            type: this.type,
            division: 'progress',
            values: cf.upSortReserves(data),
          };
          this.$store.commit('user/counseling/putCounselorDatas', commitData);

          // 報告書未記入は1ページ目でしか表示しない。
          // すでに読み込み済みの場合は再取得しない
          if (isForceGet || (this.page === 1 && !this.targetCounselorReserve.report.length)) {
            this.getReport();
          } else {
            this.flag.loaders.report = false;
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loaders.progress = false;
        });
    },

    /**
     * 報告書未記入を取得
     */
    getReport() {
      const params = {
        to_user_id: this.user.id,
        orderBy: 'desc',
        report: 1,
        isRisk: 1,
        withWho5: true,
        withType: true,
        withMeeting: true,
        isUserWatch: 1,
        counseling_type: this.counseling_type,
        targetColumn: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.targetColumn : null,
        keyword: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.keyword : null,
        school_id: this.searchCondition.clientSchool || null,
        only_watched_user: this.isOnlyWatchedUser(),
        only_my_client_data: this.isOnlyMyClient(),
        only_my_client_counselor_id: this.isOnlyMyClient() ? this.user.id : null,
      };

      this.axios({
        method: 'GET',
        url: '/v2/reserve/get/list',
        params,
      })
        .then((response) => {
          const data = response.data.result.data;

          const commitData = {
            userId: this.user.id,
            type: this.type,
            division: 'report',
            values: cf.upSortReserves(data),
          };
          this.$store.commit('user/counseling/putCounselorDatas', commitData);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loaders.report = false;
        });
    },

    // 該当利用者の直近の未実施オンライン・バーチャル健康相談を取得
    async getMostRect(reserve) {
      try {
        const futureReserve = [];

        const params = {
          from_user_id: reserve.from_user_id,
          orderBy: 'asc',
          progress: 1,
          withWho5: true,
          withType: true,
          withMeeting: true,
          isUserWatch: 1,
          isRisk: 1,
        };
        {
          // まずはオンライン健康相談を取得
          params.counseling_type = 1;
          const response = await this.axios({
            method: 'GET',
            url: '/v2/reserve/get/list',
            params,
          });
          if (response.data.result) {
            const res = response.data.result.data;
            
            res.forEach((data) => { // 該当予約以外の予約
              if (data.from_user_id === reserve.from_user_id && data.id !== reserve.id) {
                futureReserve.push(data);
              }
            });
          }
        }
        {
          // 次にバーチャル健康相談を取得
          params.counseling_type = 3;
          const response = await this.axios({
            method: 'GET',
            url: '/v2/reserve/get/list',
            params,
          });
          if (response.data.result) {
            const res = response.data.result.data;

            res.forEach((data) => { // 該当予約の予約
              if (data.from_user_id === reserve.from_user_id && data.id !== reserve.id) {
                futureReserve.push(data);
              }
            });
          }
        }

        // 最後に未来の予約をセット（schedule.dateの昇順）
        reserve.nearest = futureReserve.sort((a, b) => moment(a.schedule.date).diff(moment(b.schedule.date)));

      } catch (error) {
        if (error.message) console.log(error);
        else console.log(error);
      }
    },

    isCompany(row) {
      return Boolean(row && row.fromUser && row.fromUser.school.length && row.fromUser.school[0].is_company);
    },
    // 企業固有のお悩みサブ項目ゲート専用。is_company（非学校）と別に is_corporate も要求し、
    // インターン(id=18)では false にする。お悩みラベル(#3238)は isCompany のまま据え置く。
    isCorporate(row) {
      return this.isCorporateSchool(row?.fromUser?.school);
    },

    changeOpenIds(n, name) {
      if (this.openIds[name].includes(n)) {
        const idx = this.openIds[name].indexOf(n);
        this.openIds[name].splice(idx, 1);
      } else {
        this.openIds[name].push(n);

        // 予約データに対する学校メモの既読処理
        if (name === 'reserve') {
          const targetReserve = this.targetCounselorReserve.progress.find((r) => r.id === n);
          if (this.newFlagsChecker(targetReserve)) {
            // Newマークが表示中の予約の詳細を開いた場合、学校メモの既読フラグを登録
            setTimeout(() => {
              this.registerSchoolMemoReadFlag(targetReserve.memos.teacher[0].id);
            }, 3000); // 3秒後に既読フラグを登録
          }
        }
      }
    },

    /** 予約をschedule.dateの昇順でソート */
    upSortReserves() {
      if (!this.targetReserves.length) {
        this.flag.loaders = { progress: false, report: false, finished: false };
        return;
      }

      const progress = [];
      const report = [];
      const finished = [];
      const clone = cloneDeep(this.targetReserves);
      clone.forEach((row) => {
        if (row.flag === 1) progress.push(row);
        else if (row.flag === 11 && (!row.report || (row.report && row.report.flag === 2))) report.push(row);
        // キャンセル（901,902）も実施済みに含める
        else if ((row.flag === 11 && row.report && row.report.flag === 1) || row.flag === 901 || row.flag === 902) finished.push(row);
      });

      this.progress = cf.upSortReserves(progress);
      this.report = cf.upSortReserves(report);

      // loaderフラグ更新
      this.flag.loaders = { progress: false, report: false };
    },

    /** 当日現れず医師がキャンセル */
    cancel(reserve) {
      const args = {
        modalName: 'reserveCancel',
        data: {
          reserve_id: reserve.id,
          counseling_type: this.counseling_type,
          schedule: reserve.schedule,
          customer_id: reserve.fromUser?.customer_id,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: null });
    },

    getDisplayMemo(fReserve) {
      if (fReserve && fReserve.memos && fReserve.memos.customer && fReserve.memos.customer[0]) {
        return fReserve.memos.customer[0].memo;
      }
      return null;
    },

    receiveValue(data) {
      const userIdRegex = new RegExp(/^[0-9０-９]{4}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{1,}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{4}$/);
      if (userIdRegex.test(data.value)) {
        const userId = data.value.split(/[-|ー|−|―|‐|-|ｰ]/);
        this.searchCondition.keyword = String(Number(cf.toHalfNumber(userId[2]))); // user.id指定
        this.searchCondition.targetColumn = ['id', 'old_id'];
      } else {
        this.searchCondition.keyword = data.value;
        this.searchCondition.targetColumn = ['username', 'kana', 'id', 'old_id'];
      }
    },

    // 検索実行
    registKeyword(e) {
      e.preventDefault();
      if (this.searchCondition.keyword === '') this.searchCondition.keyword = null;

      // 各種データ初期化
      this._clearDataBeforeSearch();

      this.getFinished(true); // 実施済みを取得（その流れで予約・報告書未記入も取得する）
    },

    // クライアントの所属学校データを取得
    // 取得したデータを検索用のプルダウンとして表示する
    async getClientSchools() {
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/reserve/get/clientSchools',
          params: {
            to_user_id: this.user.id,
            counseling_type: this.counseling_type,
          },
        });
        this.clientSchools = response.data.clientSchools;
      } catch (error) {
        alert('クライアントの所属学校データの取得に失敗しました。');
        console.error(error);
      }
    },

    _clearDataBeforeSearch() {
      this.flag.loaders = { progress: true, report: true, finished: true };
      this.openIds = { reserve: [], report: [] };
      this.pageMax = 1;
      this.page = 1;
      this.$store.commit('user/counseling/clearCounselorDatas'); // ストアのカウンセラー用データをクリア
      this.$router.replace(`/counselor/?tab=${this.tab}&page=1`);
    },

    isOnlyWatchedUser() {
      // チェックボックスで表現する検索条件
      return this.activeTypeItems.find((item) => item.name === 'isWatched' && item.checked) ? 1 : 0;
    },
    isOnlyMyClient() {
      // チェックボックスで表現する検索条件
      return this.activeTypeItems.find((item) => item.name === 'onlyMyClient' && item.checked) ? 1 : 0;
    },
    // isOnlyLatestByUser() {
    //   // チェックボックスで表現する検索条件
    //   return this.activeTypeItems.find((item) => item.name === 'onlyLatestByUser' && item.checked) ? 1 : 0;
    // },

    // ２週間アラートデータが更新された後の処理
    afterUpdateUserWatchData() {
      this.getFinished(); // 表示データを更新する（「実施済み」のみ）
    },
    newFlagsChecker(reserve) {
      // 学校メモが存在しない場合はNewマークを表示しない
      if (!reserve || !reserve.memos || !reserve.memos.teacher || !reserve.memos.teacher.length) return false;
      // 学校メモが存在し、かつ既読IDが一切ない場合はNewマークを表示
      if (!this.user.readflags || !this.user.readflags.reserveMemos) return true;

      const readReserveMemoIds = this.user.readflags.reserveMemos; // 既読済みのメモID一覧
      const reserveMemo = reserve.memos.teacher.length ? reserve.memos.teacher[0] : null; // 学校メモ（最新）
      if (!reserveMemo) return false;
      return !readReserveMemoIds.includes(reserveMemo.id);
    },
    async registerSchoolMemoReadFlag(reserveMemoId) {
      const data = {
        model_type: 9, // 予約メモ
        user_id: this.user.id,
        foreign_id: reserveMemoId,
      };
      await this.axios({
        method: 'POST',
        url: '/v1/readflag/set/register',
        data,
      });
      // storeのフラグを更新
      this.$store.dispatch('user/update');
    },

    // 自分が最終相談者になっている２週間アラート相談者データを取得
    async getMyWatchedClients() {
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/userWatch/get/myClients',
          params: {
            counselor_id: this.user.id,
          },
        });
        this.myWatchedClients = response.data.data;
      } catch (error) {
        alert('自分のクライアントデータの取得に失敗しました。');
        console.error(error);
      }
    },
    isMyCustomer(userId) {
      return !!this.myWatchedClients.find((u) => u.user_id === userId);
    },
  },
};
</script>

<style lang="scss" module>
.wordsearch {
  display: flex;
  align-items: center;
  &_form {
    flex: 1;
  }
  &_btn {
    background-color: var(--orange-main);
    color: #fff;
    margin-left: 10px;
    padding: 15px 30px;
    border-radius: 30px;
    font-weight: bold;
    cursor: pointer;
  }
}
.reserves {
  li {
    &:not(:first-child) {
      .reserve {
        margin-top: 16px;
      }
    }
  }
}
.list {
  display: flex;
  align-items: center;
  color: var(--black);

  &_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include sm-view {
      margin-top: 10px;
      justify-content: right;
    }
  }
  @include sm-view {
    flex-wrap: wrap;
    .label {
      width: 100%;
      margin-bottom: 1em;
    }
    .text_wrap {
      flex: 1;
      padding-right: 1em;
    }
  }
}
.label {
  width: 140px;
  min-width: 140px;
  margin-right: 20px;
}
.postUser {
  // メモ本文の上に投稿者氏名＋最終更新日時を表示
  font-weight: bold;
  font-size: 13px;
}
.text_wrap {
  margin-left: 15px;
}
.id {
  font-size: 12px;
}
.top_btn {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.icon {
  cursor: pointer;
  font-size: 20px;
  // color: var(--gray-main);
  color: --gray-side;
}
.detail {
  li {
    display: flex;
    align-items: flex-start;
    .content {
      // font-size: 14px;
      margin-top: 3px;
      flex: 1;
      // 学校メモ・事務局メモ・相談内容など長文表示の折り返し（#3244）
      word-break: break-all;
      overflow-wrap: break-word;
    }
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
  @include sm-view {
    li {
      display: block;
    }
    .label {
      width: 100%;
    }
    .content {
      flex: 1;
    }
    font-size: 14px;
  }
}
.who5 {
  li {
    justify-content: space-between;
  }
  @include sm-view {
    li {
      display: block;
      p {
        &:first-child {
          font-size: 13px;
        }
        &:not(:first-child) {
          font-weight: bold;
        }
      }
    }
  }
  .who5_answer {
    font-weight: bold;
  }
}
.who5score {
  // font-size: 14px;
  color: var(--black);
  .who5label {
    margin-right: 12px;
  }
}
.chartIcon {
  margin-left: 8px;
  cursor: pointer;
  color: #58b3b1;
  &:hover {
    opacity: 0.7;
  }
}
.done {
  cursor: pointer;
  outline: none;
  background-color: transparent;
  border: 1px solid var(--black);
  padding: 4px 12px;
  border-radius: 24px;
  margin-right: 10px;
}
.value {
  flex: 1;
  margin-top: 3px;
  &.type {
    display: flex;
    flex-wrap: wrap;
    p {
      white-space: nowrap;
      &:not(:last-child) {
        &::after {
          margin: 0 5px;
          content: '/';
        }
      }
      // 「その他」自由記述などで長い半角英字連続が来た時の折り返し（#3244）
      > span {
        word-break: break-all;
        overflow-wrap: break-word;
        white-space: normal;
        // 自由記述は本文 bold とは別の通常重みで表示する
        font-weight: normal;
      }
    }
  }
  // sub_type が保存されているレコード（企業ユーザー）はメインを縦並びにしてセパレータを消す
  &.typeCompany {
    display: block;
    p {
      white-space: normal;
      &:not(:last-child)::after {
        content: '';
        margin: 0;
      }
    }
  }
}
.cancel_detail {
  .comment {
    font-size: 14px;
    margin-top: .5em;
    dt {
      font-weight: bold;
    }
    dd {
      margin: .3em 0 0 0;
    }
  }
}

.nearest_box {
  width: 78%;
}

.fReserve {
  &_content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_label {
    background-color: var(--gray-sub);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    padding: .3em 1em;
    border-radius: 5px;
    width: 140px;
  }
  &_value {
    padding-left: 1em;
  }
  &_center {
    align-items: stretch !important;
  }
  &_none {
    display: flex;
    align-items: center;
  }
}

.select {
  display: flex;
  dl {
    display: flex;
    align-items: center;
    margin: 0;
  }
  dt {
    min-width: 6em !important;
    i {
      margin-right: .5em;
    }
  }
  dd {
    width: 65%;
    display: flex;
    align-items: center;
    margin-left: 1em;
  }
  @include sm-view {
    dl {
      display: block;
      margin: 1em 0 .4em;
    }
    dt {
      font-size: 14px;
    }
    dd {
      margin: 0;
    }
  }
  &_box {
    width: 300px;
    padding: 13px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    border-radius: 8px;
    appearance: none;

    &_wrap {
      display: flex;

      li {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
  li {
    // 2つ目以降のチェックボックスにmargin-leftをつける
    &:not(:first-child) {
      margin-left: 1rem;
    }
  }
}

.counseling {
  display: flex;
  align-items: center;
  &_wrap {
    display: flex;
    align-items: center;
  }
  &_icon {
    font-size: 25px !important;
    position: relative;
    &_inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      font-size: 10px !important;
    }
    &.online {
      color: var(--orange-main);
    }
    &.virtual {
      color: var(--green-main);
    }
  }
}
// 過去予約の <span> も企業ユーザー時は縦並びにしてサブが見やすいように
.fReserveTypeCompany {
  display: block;
}
// 企業サイト: メイン項目の下に「選択済み」サブ項目を ' / ' 連結で表示する。
// 表示形は予約入力の確認ステップ（ReserveFormWizard の確認欄）に合わせてある。
// span を block 化して親 <p> 内で改行させる。テンプレ側は1行で書くこと
// （親に white-space: pre-wrap が効く画面があり、改行・インデントが空白として可視化されるため）。
.subList {
  display: block;
  margin: 2px 0 8px 20px;
  font-size: 13px;
  color: #555;
}
</style>
